import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import customBuild from "src/ckeditor5/build/ckeditor";
import {
  PaymentProviderIDs,
  VendorsNames,
  VendorsTypes,
  mobCountries,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import {
  MenuButton,
  Smtp,
  Tab,
  ThirdPartyInfoUI,
} from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
import {
  GetMessagingVendor,
  GetPaymentProviders,
  SaveThirdPartyInfoMethod,
  SetPaymentProvider,
  TestThirdPartyInfoMethod,
} from "src/app/core/services/outbound";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import Swal from "sweetalert2";
import country from "src/assets/country.json";
import currencies from "src/assets/currency.json";

@Component({
  selector: "app-gen-appPayment-googlepay",
  templateUrl: "./gen-appPayment-googlepay.component.html",
  styleUrls: ["./gen-appPayment-googlepay.component.scss"],
})
export class GenAppPaymentGooglePayComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private builderService: BuilderService,
    private modalService: BsModalService,
  ) {}

  stripeform: UntypedFormGroup; // bootstrap validation form

  @Input() button_id: string;
  @Input() page_id: string;
  @Input() gateway: string;
  button: MenuButton;
  mode: string;
  public Editor = customBuild;
  // default values
  offCanvasSubscription: any;

  offcanvasColors = offcanvasColors;
  newTab = false;
  button_label: string;
  row_id: string;
  labelColor = "#ffffff";
  data: any;
  currentMenuSubscription: any;
  verifySubscription: any;
  paymentProvidersSubscription: any;
  testedMessagingSubscription: any;
  thirdPartyInfoSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  component_id: string;
  field_id: string;
  component_ref: any;

  message: any;

  submitted = false;
  vendorTestSubmitted = false;

  loadding = false;

  smtpOpj: Smtp;
  app_info: any = {};
  showTest = false;
  modalRef?: BsModalRef;
  paymentProviderIDs = PaymentProviderIDs;
  stripeConf: any;
  countries = country;
  currencies = currencies;

  ngOnInit() {
    this.component_ref = this.mdw.makeRef(16);
    console.log(this.gateway);
    this.stripeform = this.formBuilder.group({
      active: new UntypedFormControl(1),
      provider_id: new UntypedFormControl(this.paymentProviderIDs.GOOGLEPAY),
      merchantName: new UntypedFormControl("", [Validators.required]),
      countryCode: new UntypedFormControl("", [Validators.required]),
      currencyCode: new UntypedFormControl("", [Validators.required]),
      environment: new UntypedFormControl("TEST", [Validators.required]),
      stripe_publishableKey: new UntypedFormControl("", [Validators.required]),
      merchantId: new UntypedFormControl("", [Validators.required]),
      clientKey: new UntypedFormControl("", [Validators.required]),
      api_key: new UntypedFormControl("", [Validators.required]),
      webhook_secret: new UntypedFormControl("", [Validators.required]),
    });

    this.enableControls();

    this.field_id = "label";

    this.sortedButtonList = [];
    this.buttonList = {};

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      },
    );

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];

          this.buttonFunction();
        }
      },
    );

    this.paymentProvidersSubscription =
      this.ws.paymentProvidersContainer$.subscribe((data) => {
        if (data && data.ref === this.component_ref) {
          const provider = data.data.find(
            (provider) =>
              provider.provider_id === this.paymentProviderIDs.GOOGLEPAY,
          );
          this.stripeConf =
            provider && provider.config ? provider.config : null;
          let parameters =
            provider &&
            provider.config &&
            provider.config.allowedPaymentMethods &&
            provider.config.allowedPaymentMethods[0] &&
            provider.config.allowedPaymentMethods[0]
              .tokenizationSpecification &&
            provider.config.allowedPaymentMethods[0].tokenizationSpecification
              .parameters
              ? provider.config.allowedPaymentMethods[0]
                  .tokenizationSpecification.parameters
              : null;
          this.mdw._paymentPROContainer.next(data.data);
          this.stripeform = this.formBuilder.group({
            active: new UntypedFormControl(1),
            provider_id: new UntypedFormControl(
              this.paymentProviderIDs.GOOGLEPAY,
            ),
            merchantName: new UntypedFormControl(
              provider &&
                provider.config &&
                provider.config.merchantInfo &&
                provider.config.merchantInfo.merchantName
                ? provider.config.merchantInfo.merchantName
                : "",
              [Validators.required],
            ),
            countryCode: new UntypedFormControl(
              provider &&
                provider.config &&
                provider.config.transactionInfo &&
                provider.config.transactionInfo.countryCode
                ? provider.config.transactionInfo.countryCode.toLowerCase()
                : "",
              [Validators.required],
            ),
            currencyCode: new UntypedFormControl(
              provider &&
                provider.config &&
                provider.config.transactionInfo &&
                provider.config.transactionInfo.currencyCode
                ? provider.config.transactionInfo.currencyCode
                : "",
              [Validators.required],
            ),
            environment: new UntypedFormControl(
              provider && provider.config && provider.config.environment
                ? provider.config.environment
                : "TEST",
              [Validators.required],
            ),
            stripe_publishableKey: new UntypedFormControl(
              parameters && parameters["stripe:publishableKey"]
                ? parameters["stripe:publishableKey"]
                : "",
              [Validators.required],
            ),
            merchantId: new UntypedFormControl(
              parameters && parameters.merchantId ? parameters.merchantId : "",
              [Validators.required],
            ),
            clientKey: new UntypedFormControl(
              parameters && parameters.clientKey ? parameters.clientKey : "",
              [Validators.required],
            ),
            api_key: new UntypedFormControl(provider && provider.config && provider.config.gatewayInfo && provider.config.gatewayInfo.api_key ? provider.config.gatewayInfo.api_key : "", [Validators.required]),
            webhook_secret: new UntypedFormControl(provider && provider.config && provider.config.gatewayInfo && provider.config.gatewayInfo.webhook_secret ? provider.config.gatewayInfo.webhook_secret : "", [Validators.required]),
          });

          this.enableControls();
        }
      });
    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData) {
          const appInfo = this.indexDBService.getItem("item", "app_info");
          appInfo.onsuccess = (event) => {
            if (appInfo.result) {
              this.app_info = appInfo.result;
              this.buttonFunction();
            }
          };
        }
      },
    );
  }

  buttonIntialize(data) {
    this.data = data.data;
    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.stripeform);
    if (this.stripeform.invalid) {
      return;
    } else {
      this.setSmtpServer();
    }
  }

  async setSmtpServer() {
    const config = {
      environment: this.stripeform.value.environment,
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: "CARD",
          parameters: {
            // allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
            // PAN ONLY are the cards stored in chrome or google account which might need a 3d auth.

            allowedAuthMethods: [ "CRYPTOGRAM_3DS"],
            allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX"],
          },
          tokenizationSpecification: {
            type: "PAYMENT_GATEWAY",
            parameters: {},
          },
        },
      ],
      merchantInfo: {
        merchantName: this.stripeform.value.merchantName,
      },
      transactionInfo: {
        totalPriceStatus: "FINAL",
        currencyCode: this.stripeform.value.currencyCode,
        countryCode: this.stripeform.value.countryCode.toUpperCase(),
      },
      gatewayInfo: {
        gateway_id: this.gateway
      }
    };
    let parameters = {};
    if (this.gateway == "stripe") {
      config['gatewayInfo']["api_key"] = this.stripeform.value.api_key;
      config['gatewayInfo']["webhook_secret"] = this.stripeform.value.webhook_secret;
      config['gatewayInfo']["publishableKey"] = this.stripeform.value.stripe_publishableKey;
      parameters["gateway"] = this.gateway;
      parameters["stripe:version"] = "2018-10-31";
      parameters["stripe:publishableKey"] =
        this.stripeform.value.stripe_publishableKey;
    }
    if (this.gateway == "braintree") {
      parameters["gateway"] = this.gateway;
      parameters["braintree:apiVersion"] = "v1";
      parameters["braintree:sdkVersion"] = "braintree.client.VERSION";
      parameters["braintree:merchantId"] = this.stripeform.value.merchantId;
      parameters["braintree:clientKey"] = this.stripeform.value.clientKey;
    }
    if (this.gateway == "adyen") {
      parameters["gateway"] = this.gateway;
      parameters["gatewayMerchantId"] = this.stripeform.value.clientKey;
    }

    config.allowedPaymentMethods[0].tokenizationSpecification.parameters =
      parameters;

    this.ws.processMethod(
      new SetPaymentProvider(
        this.stripeform.value.active,
        config,
        this.stripeform.value.provider_id,
        this.component_ref,
      ),
    );
  }

  buttonFunction() {
    const payments = this.mdw.getPaymentProviders();
    const provider = payments.find(
      (provider) => provider.provider_id === this.paymentProviderIDs.GOOGLEPAY,
    );
    this.stripeConf = provider && provider.config ? provider.config : null;
    let parameters =
      provider &&
      provider.config &&
      provider.config.allowedPaymentMethods &&
      provider.config.allowedPaymentMethods[0] &&
      provider.config.allowedPaymentMethods[0].tokenizationSpecification &&
      provider.config.allowedPaymentMethods[0].tokenizationSpecification
        .parameters
        ? provider.config.allowedPaymentMethods[0].tokenizationSpecification
            .parameters
        : null;
    this.stripeform = this.formBuilder.group({
      active: new UntypedFormControl(1),
      provider_id: new UntypedFormControl(this.paymentProviderIDs.GOOGLEPAY),
      merchantName: new UntypedFormControl(
        provider &&
          provider.config &&
          provider.config.merchantInfo &&
          provider.config.merchantInfo.merchantName
          ? provider.config.merchantInfo.merchantName
          : "",
        [Validators.required],
      ),
      countryCode: new UntypedFormControl(
        provider &&
          provider.config &&
          provider.config.transactionInfo &&
          provider.config.transactionInfo.countryCode
          ? provider.config.transactionInfo.countryCode.toLowerCase()
          : "",
        [Validators.required],
      ),
      currencyCode: new UntypedFormControl(
        provider &&
          provider.config &&
          provider.config.transactionInfo &&
          provider.config.transactionInfo.currencyCode
          ? provider.config.transactionInfo.currencyCode
          : "",
        [Validators.required],
      ),
      environment: new UntypedFormControl(
        provider && provider.config && provider.config.environment
          ? provider.config.environment
          : "TEST",
        [Validators.required],
      ),
      stripe_publishableKey: new UntypedFormControl(
        parameters && parameters["stripe:publishableKey"]
          ? parameters["stripe:publishableKey"]
          : "",
        [Validators.required],
      ),
      merchantId: new UntypedFormControl(
        parameters && parameters["braintree:merchantId"]
          ? parameters["braintree:merchantId"]
          : "",
        [Validators.required],
      ),
      clientKey: new UntypedFormControl(
        parameters && parameters["braintree:clientKey"]
          ? parameters["braintree:clientKey"]
          : "",
        [Validators.required],
      ),
      api_key: new UntypedFormControl(provider && provider.config && provider.config.gatewayInfo && provider.config.gatewayInfo.api_key ? provider.config.gatewayInfo.api_key : "", [Validators.required]),
      webhook_secret: new UntypedFormControl(provider && provider.config && provider.config.gatewayInfo && provider.config.gatewayInfo.webhook_secret ? provider.config.gatewayInfo.webhook_secret : "", [Validators.required]),
    });

    this.enableControls();
  }

  buttonLabel() {
    if (this.f && this.f.lableControl.valid) {
      this.button.button_label = this.f.lableControl.value;
      this.updateButtonData();
    }
  }

  get f() {
    if (this.stripeform && this.stripeform.controls) {
      return this.stripeform.controls;
    }
  }

  colorChange(event) {
    this.button.button_label_color = this.labelColor;
    this.updateButtonData();
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id,
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;
    this.data["component_id"] = this.component_id;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "splash" } },
      this.mode,
      true,
    );
  }

  enableStripePayment(status) {
    this.stripeform.patchValue({
      active: status ? 1 : 0,
    });

    if (status) {
      this.stripeform.get("api_key").enable();
      this.stripeform.get("publish_key").enable();
      this.stripeform.get("webhook_secret").enable();
    } else {
      this.stripeform.get("api_key").disable();
      this.stripeform.get("publish_key").disable();
      this.stripeform.get("webhook_secret").disable();
    }
  }

  enableControls() {
    if (this.gateway == "stripe") {
      this.stripeform.get("stripe_publishableKey").enable();
      this.stripeform.get("api_key").enable();
      this.stripeform.get("webhook_secret").enable();
      this.stripeform.get("merchantId").disable();
      this.stripeform.get("clientKey").disable();
    } else if (this.gateway == "braintree") {
      this.stripeform.get("stripe_publishableKey").disable();
      this.stripeform.get("api_key").disable();
      this.stripeform.get("webhook_secret").disable();
      this.stripeform.get("merchantId").enable();
      this.stripeform.get("clientKey").enable();
    } else {
      this.stripeform.get("stripe_publishableKey").disable();
      this.stripeform.get("api_key").disable();
      this.stripeform.get("webhook_secret").disable();
      this.stripeform.get("merchantId").enable();
      this.stripeform.get("clientKey").disable();
    }
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.paymentProvidersSubscription) {
      this.paymentProvidersSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
    if (this.testedMessagingSubscription) {
      this.testedMessagingSubscription.unsubscribe();
    }
    if (this.thirdPartyInfoSubscription) {
      this.thirdPartyInfoSubscription.unsubscribe();
    }
  }
}
